module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showNav) ? _c('div', {
    attrs: {
      "id": "navigationbar"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "navigationbar-title"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div')]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dcbece0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/navbar/navigationbar.vue
// module id = 581
// module chunks = 1